// src/components/PublicRoute.jsx
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';
import { Skeleton } from "@/components/ui/skeleton";

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <Skeleton className="w-32 h-32" />
      </div>
    );
  }

  if (user) {
    // If the user is authenticated, redirect to the dashboard
    return <Navigate to="/dashboard" replace />;
  }

  // If not authenticated, render the child component
  return children;
};

export default PublicRoute;
